function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_1"
}, React.createElement("title", null, "Layer 1"), React.createElement("path", {
  id: "svg_1",
  d: "m450,100c0,-27.16895 22.83105,-50 50,-50l200,0c27.16895,0 50,22.83105 50,50l0,400c0,27.16895 -22.83105,50 -50,50l-200,0c-27.16895,0 -50,-22.83105 -50,-50l0,-400z"
}), React.createElement("path", {
  id: "svg_2",
  d: "m51,400c0,-27.16895 22.83105,-50 50,-50l200,0c27.16895,0 50,22.83105 50,50l0,100c0,27.16895 -22.83105,50 -50,50l-200,0c-27.16895,0 -50,-22.83105 -50,-50l0,-100z"
}), React.createElement("path", {
  id: "svg_3",
  d: "m50,100.00001c0,-27.16895 22.83105,-50 50,-50l200,0c27.16895,0 50,22.83105 50,50l0,100.00001c0,27.16895 -22.83105,50 -50,50l-200,0c-27.16895,0 -50,-22.83105 -50,-50l0,-100.00001z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    "data-name": "Layer 1"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/screens-icon_3b.d77f1b40.svg";
export { SvgComponent as ReactComponent };